/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import Tojo from "assets/images/tojo-rakotozafy.jpg"
function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="computer"
                    title="Système d'information"
                    description="Conception et gestion de systèmes pour collecter, traiter et diffuser l'information efficacement au sein d'une organisation."
                  />

                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="map"  // icône représentative de la géomatique/SIG
                    title="Géomatique / SIG"
                    description="Gestion, analyse et visualisation de données géospatiales pour soutenir la planification et la prise de décision stratégique."
                  />


                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="analytics" // icône plus représentative de l'analyse et décision
                    title="Prise de décision"
                    description="Analyse des données et informations pertinentes pour soutenir des décisions stratégiques et éclairées."
                  />

                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="brush"  // icône plus représentative du design graphique
                    title="Designer graphique"
                    description="Création de visuels impactants et esthétiques pour communiquer des idées et valoriser l’identité visuelle."
                  />

                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={Tojo}
              title="Tojo Tiana Rakotozafy"
              description="Ingénieur spécialisé en Systèmes d’information, Géomatique et Décision.   Fortes   compétences   dans   la   conception   et
Développement logiciel , Géomatique, Cartographie,Télédetection,Analyse spatiale , Designer graphique .
Cherche à contribuer à des projets stimulants, en mettant en œuvre mon
expertise  pour  optimiser  l’analyse  des  données  et  fournir  des  insights
précieux aux entreprises."

              action={{
                type: "external",
                route: "https://www.linkedin.com/in/tojotiana-rakotozafy",
                color: "info",
                label: "LinkedIN",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
